/**
 * @generated SignedSource<<b22c3dba2b52029a8891d18b3d41c50c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConfigurableMenuItems$data = {
  readonly jira: {
    readonly userNavigationConfiguration: {
      readonly navItems: ReadonlyArray<{
        readonly isVisible: boolean;
        readonly menuId: string;
      }>;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ConfigurableMenuItem" | "useShowRoadmapsUpsell">;
  readonly " $fragmentType": "ConfigurableMenuItems";
};
export type ConfigurableMenuItems$key = {
  readonly " $data"?: ConfigurableMenuItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfigurableMenuItems">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "isRoadmapUpsellEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "ConfigurableMenuItems",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudID",
              "variableName": "cloudId"
            },
            {
              "kind": "Literal",
              "name": "navKey",
              "value": "NAV_SIDEBAR"
            }
          ],
          "concreteType": "JiraUserNavigationConfiguration",
          "kind": "LinkedField",
          "name": "userNavigationConfiguration",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraConfigurableNavigationItem",
              "kind": "LinkedField",
              "name": "navItems",
              "plural": true,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "menuId"
                  },
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "isVisible"
                  },
                  "action": "THROW"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ConfigurableMenuItem"
    },
    {
      "condition": "isRoadmapUpsellEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useShowRoadmapsUpsell"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "dbd1b24ca8e6a8630a5c24e277c90272";

export default node;
